import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { Dialog } from '@headlessui/react';
import { useForm } from "react-hook-form";
import Cookies from 'universal-cookie';

export const Footer = () => {
  let [isOpen, setIsOpen] = useState(true)
  const { register, handleSubmit, formState: { errors } } = useForm();
  const onSubmit = data => console.log(data);
  const cookies = new Cookies();

  return (
    <>
      <footer className="xl:p-14 p-8 pb-10 text-white">
        <div className="">
          <h4 className="text-3xl font-light">Buy The Best Eyewear From Sightkart</h4>
          <p className="font-light mt-6 mb-3 text-sm">Sightkart Is The Leading E-Commerce Portal For Eyewear. It Has Revolutionised The Eyewear Industry In The Country With Its Omni-Channel Approach. From An Ever-Growing Number Of Offline Stores Across Major Cities In The Country To Innovative Integration Of Technology While Purchasing Online, Sightkart Caters To Every Customer With Several Deals And Offers.</p>
          <p className="font-light text-sm">A One-Stop Online Solution For Purchasing Eyewear And Its Accessories, Sightkart Delivers Them Right At Your Doorstep With Convenient Methods Of Payment. Sunglasses As Well As Eyeglasses Are Available For Men And Women In A Diverse Array Of Styles And Trendy Colours.</p>
        </div>
        <div className="grid grid-cols-1 space-y-8 xl:space-y-0 lg:grid-cols-4 text-white mt-16 justify-between">
          <div>
            <h3 className="uppercase font-light mb-4">SHOP</h3>
            <ul className="space-y-2 font-light text-sm">
              <li><Link to="#">Eyeglasses For Men</Link></li>
              <li><Link to="#">Eyeglasses For Women</Link></li>
              <li><Link to="#">Magnetic Clip-Ons</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="uppercase font-light mb-4">SERVICES</h3>
            <ul className="space-y-2 font-light text-sm">
              <li><Link to="#">Store Locations</Link></li>
              <li><Link to="/returns-exchanges">Return & Exchanges</Link></li>
              <li><Link to="#">About Us</Link></li>
              <li><Link to="/terms-conditions">Terms & Conditions</Link></li>
              <li><Link to="/shipping-delivery">Shipping & Delivery</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="uppercase font-light mb-4">HELP</h3>
            <ul className="space-y-2 font-light text-sm">
              <li><Link to="#">Eyeglasses For Men</Link></li>
              <li><Link to="#">Eyeglasses For Women</Link></li>
              <li><Link to="#">Magnetic Clip-Ons</Link></li>
              <li><Link to="/faq">FAQ's</Link></li>
            </ul>
          </div>
          <div className="">
            <p className="mb-4">FOLLOW US AT</p>
            <div className="flex gap-4">
              <Link to="#"><i className="fa fa-facebook"></i></Link>
              <Link to="#"><i className="fa fa-instagram"></i></Link>
            </div>
          </div>
        </div>
      </footer>

      {/* {cookies.set('newsletter', 'Pacman', { path: '/' })}
      {console.log(cookies.get('newsletter'))}
      <Dialog open={isOpen} onClose={() => setIsOpen(false)} className="newsletter scroll-auto z-[999]" aria-hidden="false">
        <div className="fixed bottom-10 xl:right-10 right-0 flex items-center justify-center p-4">
          <Dialog.Panel className="max-w-lg rounded bg-white shadow-xl border-2 border-gray-100 ">
            <div className="bg-cyan-500 text-white py-4 px-5 w-full text-xl relative">
              <h2>Never miss a deal!</h2>
              <button onClick={() => setIsOpen(false)} className="absolute right-4 top-4 focus-visible:outline-none"><i className="fa fa-times"></i></button>
            </div>
            <div className="px-4 py-8">
              <div className="flex gap-5">
                <i className="fa fa-paper-plane text-cyan-500 text-5xl"></i> <span>Have our daily deals delivered piping hot to your inbox</span>
              </div>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="flex mt-6">
                  <div class="relative xl:w-[70%] w-[60%]">
                    <input name="email" type="email" {...register("email", { required: true, maxLength: 150 })} class="w-full p-1 py-3 px-4 placeholder-transparent border border-gray-200 rounded-l peer focus:outline-none focus:border-gray-500 focus:shadow-sm text-gray-700" placeholder="Your e-mail address" autocomplete="off" />
                    <label for="email" class="absolute top-0 left-0 h-full px-4 py-3 text-sm transition-all duration-100 ease-in-out origin-left transform scale-75 translate-x-1 -translate-y-3 opacity-75 pointer-events-none peer-placeholder-shown:opacity-100 peer-focus:opacity-75 peer-placeholder-shown:scale-100 peer-focus:scale-75 peer-placeholder-shown:translate-y-0 peer-focus:-translate-y-3 peer-placeholder-shown:translate-x-0 peer-focus:translate-x-1 text-gray-500">Your e-mail address</label>
                    {errors.email?.type === 'required' && <p className="mb-2 mt-1 text-xs text-red-600">Email is required</p>}
                  </div>
                  <div className="xl:w-[30%] w-[25%]">
                    <button className="uppercase bg-cyan-500 text-white py-[13px] xl:px-5 px-3 rounded-r font-light tracking-widest">Subscribe</button>
                  </div>
                </div>
              </form>
              <p className="text-sm font-light mt-3">View our <a href="/privacy-policy" className="text-cyan-600 hover:underline">Privacy Policy</a> and <a href="http://" className="text-cyan-600 hover:underline">Collection Statement</a></p>
            </div>
          </Dialog.Panel>
        </div>
      </Dialog> */}
    </>
  )
}